import { coreActions } from './reducers/core';
import { subscriptionActions } from './reducers/subscription';

const createAppActions = (dispatch, customActions = {}) => {
  const actions = {
    ...coreActions,
    ...subscriptionActions,
    ...customActions,
  };

  return Object.entries(actions).reduce(
    (wrappedActions, [key, action]) => ({
      ...wrappedActions,
      [key]: (...args) => dispatch(action(...args)),
    }),
    {},
  );
};

export default createAppActions;
